import { NmeaConfigField } from "./NmeaConfigField"

export class NmeaConfig {
        
    public name:string            
    public colHidden:Array<NmeaConfigField>
    public col1:Array<NmeaConfigField>
    public col2:Array<NmeaConfigField>
    public col3:Array<NmeaConfigField>

    constructor({name = '', col1=[], col2=[],col3=[],colHidden=[]} = {}) {
        this.name = name        
        this.colHidden = colHidden.map(c => new NmeaConfigField(c))
        this.col1 = col1.map(c => new NmeaConfigField(c))
        this.col2 = col2.map(c => new NmeaConfigField(c))
        this.col3 = col3.map(c => new NmeaConfigField(c))
    }    
}
